import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@bloomcode/ui';
import { useCookieSession } from '@bloomcode/auth';

export default function HomePage() {
  const { isAuthenticated } = useCookieSession();

  return (
    <>
      <Helmet>
        <title>Bloomcode CMS Portal - Home</title>
        <meta name="description" content="Bloomcode CMS Portal - Content management system" />
      </Helmet>

      {/* Hero Section */}
      <section className="py-20 lg:py-32">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl lg:text-6xl font-heading font-bold tracking-tight">
            Welcome to Bloomcode CMS Portal
          </h1>
          <p className="mt-6 text-xl text-muted-foreground max-w-2xl mx-auto">
            Content management powered by Bloomcode
          </p>
          <div className="mt-10 flex gap-4 justify-center">
            {isAuthenticated ? (
              <Link to="/dashboard">
                <Button size="lg">Go to Dashboard</Button>
              </Link>
            ) : (
              <>
                <Link to="/auth/register">
                  <Button size="lg">Get Started</Button>
                </Link>
                <Link to="/auth/login">
                  <Button size="lg" variant="outline">Sign In</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-muted/50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Features</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-6 bg-background rounded-lg border">
              <h3 className="text-xl font-semibold mb-2">Feature 1</h3>
              <p className="text-muted-foreground">
                Description of your first amazing feature.
              </p>
            </div>
            <div className="p-6 bg-background rounded-lg border">
              <h3 className="text-xl font-semibold mb-2">Feature 2</h3>
              <p className="text-muted-foreground">
                Description of your second amazing feature.
              </p>
            </div>
            <div className="p-6 bg-background rounded-lg border">
              <h3 className="text-xl font-semibold mb-2">Feature 3</h3>
              <p className="text-muted-foreground">
                Description of your third amazing feature.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
